<ndt-account-phone-number-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [phoneNumberPrivileges]="phoneNumberPrivileges$ | async"
   [hideHeader]="true"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
></ndt-account-phone-number-register-view>
